import { AudioMixLanguageCouple } from "./audio-mix-language-couple";

export class TranskodeOptionAudioMixes {
  selectedValues: AudioMixLanguageCouple[] | null = [];
  values: AudioMixLanguageCouple[] | null = [];
  passthrough: boolean | null = null;

  constructor(init?: Partial<TranskodeOptionAudioMixes>) {
    Object.assign(this, init);
  }

  clearValues() {
    if (this.values) {
      this.values = [];
    }
  }
}
